export const formatFormOptions = (apiData) => apiData.map(({id, name}) => {
    return {
        key: id,
        value: name
    }
})
